export default __webpack_public_path__ + "static/media/Elder Wand - Img - Wip 2_01.5d7cf8f0.jpg";